export const Stowbtsy = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [26.89055144549451, 53.85048544453059],
            [26.887031824087956, 53.849156698020636],
            [26.878996783740206, 53.84784001773971],
            [26.871854525054573, 53.845996594919654],
            [26.861141137026095, 53.84309962399834],
            [26.851766923287187, 53.84309962399834],
            [26.845071056330994, 53.84125599296419],
            [26.83748240591592, 53.83941228021888],
            [26.830786538959558, 53.83862209291328],
            [26.824090672003365, 53.83835869400792],
            [26.817841195877975, 53.83625144152853],
            [26.81650202248676, 53.83203661845221],
            [26.818287586708948, 53.827294435867316],
            [26.82275149861198, 53.82518662665814],
            [26.827215409616883, 53.82386919198217],
            [26.827215409616883, 53.820707180160355],
            [26.824537062834338, 53.81754492971078],
            [26.817394804148705, 53.814118888742314],
            [26.813377283974887, 53.81253754476461],
            [26.808913372969982, 53.81280110606059],
            [26.807574199578767, 53.81596371499802],
            [26.80578863445811, 53.81833551469509],
            [26.79953915833289, 53.819126084764605],
            [26.79552163815896, 53.819126084764605],
            [26.788825771202596, 53.81886256271167],
            [26.78436185929951, 53.81886256271167],
            [26.779897947396478, 53.81833551469509],
            [26.77454125383133, 53.8178084595192],
            [26.769184560266353, 53.8178084595192],
            [26.765167040092535, 53.82018015481361],
            [26.764274257532122, 53.82386919198217],
            [26.76338147497188, 53.83019250030583],
            [26.761149519918604, 53.832300057652446],
            [26.754900043793384, 53.833353796294375],
            [26.74731139337831, 53.83203661845221],
            [26.73838357047049, 53.829665594267055],
            [26.7321340943451, 53.82913868160051],
            [26.728116574171338, 53.829665594267055],
            [26.721420707214975, 53.831246291969535],
            [26.714278448529342, 53.83150973614073],
            [26.710707319186497, 53.82992904784993],
            [26.70535062562135, 53.828348300438165],
            [26.701779496278505, 53.82861176283603],
            [26.693298064201713, 53.82992904784993],
            [26.687048588076266, 53.83150973614073],
            [26.679459938559717, 53.83361722668019],
            [26.67008572482075, 53.83625144152853],
            [26.659372336792273, 53.83783189069652],
            [26.649998123053365, 53.838885490692064],
            [26.640623908416273, 53.83993906364856],
            [26.632142476339254, 53.84099261009652],
            [26.62767856533452, 53.84151937364504],
            [26.620982698378157, 53.8467866430596],
            [26.61919713325767, 53.84942002953079],
            [26.616072395644153, 53.85336979809529],
            [26.609376527789493, 53.85600277042346],
            [26.595538402147497, 53.85784575206793],
            [26.590181708582293, 53.85784575206793],
            [26.575004409549138, 53.8575824740966],
            [26.566969368303262, 53.85784575206793],
            [26.56116628390714, 53.85916211813742],
            [26.550452895878664, 53.86311096735409],
            [26.542864246362058, 53.862847722510935],
            [26.536168379405694, 53.86153147238991],
            [26.528579729888918, 53.85968865307609],
            [26.523223035425644, 53.858372303570945],
            [26.515187995078065, 53.85784575206793],
            [26.508938518952675, 53.858372303570945],
            [26.500903478604926, 53.86047844279608],
            [26.49152926396789, 53.86337421107066],
            [26.479030311717054, 53.86705944442048],
            [26.47233444476069, 53.869428351462886],
            [26.46474579524414, 53.87179712434988],
            [26.458942709949667, 53.87390258780465],
            [26.450014887041903, 53.876007945265485],
            [26.44331902008554, 53.87785004576625],
            [26.438408717351308, 53.87995520449499],
            [26.433944805448277, 53.88416520399443],
            [26.433944805448277, 53.88863786376584],
            [26.433944805448277, 53.89153168279029],
            [26.430373676105432, 53.893636152649094],
            [26.424570591709312, 53.893636152649094],
            [26.416535550463436, 53.89232087133979],
            [26.405375771604042, 53.89126861627591],
            [26.39957268720792, 53.89100554863501],
            [26.388412908348528, 53.890742479338314],
            [26.379092985742545, 53.89005591277652],
            [26.379139911677726, 53.889530498633746],
            [26.36654707109051, 53.88615694648587],
            [26.357961042068553, 53.885482203141294],
            [26.345940603776, 53.885482203141294],
            [26.337926977947802, 53.8841326849755],
            [26.330485753514893, 53.879746447640514],
            [26.32418933277154, 53.87468483203941],
            [26.317320510633067, 53.87097259251118],
            [26.30530007144114, 53.86185933234242],
            [26.298431249302894, 53.86050905155162],
            [26.28984522028071, 53.865909915710176],
            [26.275535173709386, 53.86793506035485],
            [26.26966805513672, 53.861922625728596],
            [26.26787929909051, 53.858757840402006],
            [26.260724276704195, 53.858757840402006],
            [26.250886118899302, 53.858757840402006],
            [26.242836718040223, 53.85401021320075],
            [26.248202985279704, 53.85031724164753],
            [26.249097362853092, 53.843458001785336],
            [26.249097362853092, 53.83501431655753],
            [26.250886118899302, 53.827624695223676],
            [26.231209805088497, 53.824457316252335],
            [26.224054781802806, 53.82128969716189],
            [26.22900633846581, 53.81727038644192],
            [26.231209805088497, 53.81548177376493],
            [26.232998561134707, 53.80756058115588],
            [26.23031542751511, 53.801222548781766],
            [26.24373109561367, 53.798581418897356],
            [26.251780496472918, 53.799637891175905],
            [26.2660905430443, 53.799637891175905],
            [26.274139944802755, 53.796996661466835],
            [26.275928700848965, 53.7901286873892],
            [26.268773676663898, 53.78537327655556],
            [26.26787929909051, 53.781674251665436],
            [26.2660905430443, 53.775332306341],
            [26.272351188756545, 53.77004662015554],
            [26.272351188756545, 53.762645541458596],
            [26.2660905430443, 53.75894451197962],
            [26.268773676663898, 53.749426083846856],
            [26.275928700848965, 53.73778951937095],
            [26.283083724134656, 53.7319700288939],
            [26.29381625861356, 53.72032862966262],
            [26.300076904325806, 53.718211665136266],
            [26.30097128189925, 53.71080145202558],
            [26.303654416418226, 53.7033899321998],
            [26.313492572424366, 53.697036162588915],
            [26.326908241422302, 53.694918026246],
            [26.346584556132484, 53.69227020540569],
            [26.362683358750076, 53.69174062073324],
            [26.370732759609325, 53.6864444142783],
            [26.36983838113656, 53.680088086096475],
            [26.36983838113656, 53.674260608740155],
            [26.363577736323634, 53.66896220344307],
            [26.367155247516735, 53.66154331547176],
            [26.36993743680688, 53.66040191431932],
            [26.378782160468404, 53.656773341016844],
            [26.385937183754095, 53.656773341016844],
            [26.39935285275203, 53.65571327324909],
            [26.407402254510487, 53.64405076962737],
            [26.423501055329496, 53.629202917680686],
            [26.438705480373642, 53.61753308098707],
            [26.453015526945194, 53.60692133894878],
            [26.46732557351652, 53.59418372819664],
            [26.4816356200879, 53.58250421030124],
            [26.495909892527663, 53.57088519699437],
            [26.504495919750923, 53.56510636306831],
            [26.512509545579064, 53.560006736721505],
            [26.52166797599631, 53.557626701611184],
            [26.532543611498568, 53.557626701611184],
            [26.542274443311044, 53.55626662000867],
            [26.545708854380166, 53.550825860125485],
            [26.545708854380166, 53.546064620785614],
            [26.54513645208573, 53.53756107668244],
            [26.54628125667483, 53.532117912012154],
            [26.542274443311044, 53.52871557796158],
            [26.532543611498568, 53.52259068850964],
            [26.522240377391597, 53.51646491412464],
            [26.51651635894285, 53.510678646402596],
            [26.513654350168167, 53.505232025637554],
            [26.51651635894285, 53.50046565836351],
            [26.523385181081323, 53.49944422457139],
            [26.534260816583526, 53.49740128234339],
            [26.542274443311044, 53.495017725487685],
            [26.549143265449516, 53.490590765051934],
            [26.552577676518638, 53.48786625092686],
            [26.556584489882425, 53.47969166084164],
            [26.557156891277657, 53.47492242293163],
            [26.555439685293322, 53.46367852584342],
            [26.550288069139242, 53.45788505185379],
            [26.549143265449516, 53.451068189845216],
            [26.550288069139242, 53.44322744429127],
            [26.553150078813076, 53.43504425398913],
            [26.55486728389809, 53.42856477714287],
            [26.56581894179078, 53.41518707482362],
            [26.57699866505652, 53.40352478793881],
            [26.57699866505652, 53.39435932032637],
            [26.558831613288362, 53.386858832369285],
            [26.52389497707162, 53.38102420540281],
            [26.51666381255677, 53.38126383213262],
            [26.517419951029524, 53.37540015156878],
            [26.51250964829552, 53.370073751077996],
            [26.509831301512918, 53.36634487473515],
            [26.503581825387528, 53.36474668503422],
            [26.496921669158667, 53.36294598639091],
            [26.490922171719035, 53.36004765991163],
            [26.4849226751777, 53.35527351630196],
            [26.48749388798109, 53.347770210351314],
            [26.491779243551775, 53.3443591803574],
            [26.498921501339055, 53.34197129644832],
            [26.512634638087548, 53.34009500855706],
            [26.52234810957657, 53.34009500855706],
            [26.531490199544237, 53.340947876923735],
            [26.537775387295483, 53.34265356248591],
            [26.54406057504673, 53.34538251801007],
            [26.552059903768452, 53.34538251801007],
            [26.5594878527657, 53.3443591803574],
            [26.564630279270716, 53.34060673162378],
            [26.56691580176272, 53.33770688638538],
            [26.576343582940297, 53.33463624655229],
            [26.582628770691542, 53.33412445184291],
            [26.590628099413266, 53.334465648998105],
            [26.6000558805909, 53.335659817547935],
            [26.606341068342147, 53.338559802512634],
            [26.610912113326094, 53.34128901949424],
            [26.618911442946114, 53.34333581760711],
            [26.624339559762745, 53.343165254850305],
            [26.636624244055326, 53.34009500855706],
            [26.64376650274096, 53.34060673162378],
            [26.650337379905295, 53.34043615795059],
            [26.655194116098983, 53.33873038369114],
            [26.661479302951875, 53.33463624655229],
            [26.661193612640318, 53.33173599533501],
            [26.65662256765654, 53.329347404550276],
            [26.65005168959391, 53.326276163423415],
            [26.652622902397297, 53.3220101834259],
            [26.660907922328875, 53.32115693635291],
            [26.670621393817896, 53.322522123480496],
            [26.675478130011754, 53.32269276880078],
            [26.684905911189333, 53.32269276880078],
            [26.69147678835367, 53.320986284891035],
            [26.6980476664163, 53.32047432641082],
            [26.702047330777077, 53.32149823722938],
            [26.708618208839766, 53.32474045941376],
            [26.711189421643326, 53.326788052298014],
            [26.719474441574903, 53.32832368207352],
            [26.732330506490484, 53.32644679373067],
            [26.741472597356506, 53.324228545972915],
            [26.749471926976526, 53.322522123480496],
            [26.75718556628533, 53.319109073233676],
            [26.766041966839964, 53.31808510509069],
            [26.775469748017372, 53.31945039102493],
            [26.78175493487032, 53.32081563274676],
            [26.790325645113512, 53.32286341343843],
            [26.795182380408903, 53.32576426840728],
            [26.7957537619302, 53.32985925657664],
            [26.795468071618586, 53.33395385224185],
            [26.797182213487588, 53.33668336398006],
            [26.799467735979533, 53.337365714622024],
            [26.807467065599553, 53.33702454066571],
            [26.8126094912065, 53.335830410325855],
            [26.815466394321504, 53.33361265099268],
            [26.817751917711746, 53.32900616645418],
            [26.81860898864619, 53.32491109586255],
            [26.82003744020375, 53.32218083079306],
            [26.82375141425308, 53.31927973220223],
            [26.834893337299718, 53.316890444539354],
            [26.84203559598535, 53.316890444539354],
            [26.85460597058932, 53.31757311180627],
            [26.861462538963337, 53.31876775324912],
            [26.866890655780196, 53.320644979919905],
            [26.873175842632918, 53.32218083079306],
            [26.88231793349911, 53.32183953537606],
            [26.891174334053744, 53.31996236178884],
            [26.893113172254516, 53.31909371810082],
            [26.892602785611132, 53.32610553243376],
            [26.891745714676745, 53.342141863981226],
            [26.89203140498813, 53.35049883839878],
            [26.892888475922575, 53.362264045080906],
            [26.89517399841452, 53.368060198872854],
            [26.89517399841452, 53.37315782810555],
            [26.89517399841452, 53.37402600413827],
            [26.893459856545746, 53.37879804635406],
            [26.890031572807743, 53.38135427812625],
            [26.884603455991112, 53.38305834703448],
            [26.87546136512492, 53.384421553058075],
            [26.867747726714583, 53.38544392893306],
            [26.86374806145534, 53.3888516717426],
            [26.864605132389897, 53.39191840656531],
            [26.868319107337584, 53.39396277423691],
            [26.874032913567532, 53.39617739449159],
            [26.877461198203775, 53.39890292329687],
            [26.880032411007164, 53.40469409182384],
            [26.880032411007164, 53.40792998945756],
            [26.882032243187552, 53.412698232618595],
            [26.889745882496186, 53.41797673544153],
            [26.900316424919765, 53.421381873103314],
            [26.906030231149714, 53.424786738617854],
            [26.907744373917012, 53.427340208410044],
            [26.910886967343345, 53.43057438383903],
            [26.918600606651978, 53.43295730261707],
            [26.927171316895, 53.43329770867933],
            [26.933456503747948, 53.432276482313114],
            [26.93888462056458, 53.42989352536347],
            [26.948312401742214, 53.42904243693209],
            [26.955740349841108, 53.431595651103066],
            [26.953454827349162, 53.43636124108417],
            [26.954026207972163, 53.43959472958727],
            [26.958025873231406, 53.44299813641669],
            [26.961454156969353, 53.44708186464709],
            [26.958597253854236, 53.45048467119011],
            [26.952597756414548, 53.455248142921846],
            [26.944884117105914, 53.45933069353498],
            [26.94259859461397, 53.46528370935965],
            [26.941741523679582, 53.47174603855245],
            [26.942884284925526, 53.481267677519725],
            [26.945455497728915, 53.489257404670525],
            [26.949455162988215, 53.49520622367203],
            [26.95374051766055, 53.499284931204784],
            [26.954026207972163, 53.503363246933816],
            [26.956597420775495, 53.52086156330677],
            [26.958311563542793, 53.52850419088168],
            [26.95545465952955, 53.53444750358426],
            [26.955272473835635, 53.53464961517466],
            [26.95116930485716, 53.53920155330849],
            [26.946026878351915, 53.54412482778014],
            [26.942312904302582, 53.54735011059569],
            [26.940884452745138, 53.55396965852117],
            [26.93945600118758, 53.562115373454276],
            [26.935742026239893, 53.56754497861391],
            [26.93002822001, 53.57008986585265],
            [26.922314580701368, 53.56941124422974],
            [26.915743702638736, 53.56924158712235],
            [26.9097442060974, 53.57076847658573],
            [26.9051731602151, 53.573822090656165],
            [26.904887469903713, 53.57755398551649],
            [26.9091728254744, 53.581455160299356],
            [26.912315418900732, 53.58399921041962],
            [26.91488663170429, 53.58756062388403],
            [26.916029392950293, 53.596038971153064],
            [26.91831491634042, 53.61383796403976],
            [26.91774353571759, 53.62858001931011],
            [26.915743702638736, 53.632645886681075],
            [26.910029896408957, 53.63654197581434],
            [26.9063159214611, 53.63959083819327],
            [26.902887637723325, 53.643994360725515],
            [26.901459186165766, 53.649074777527744],
            [26.899745044296765, 53.6551704696937],
            [26.898602283050764, 53.662280996630216],
            [26.89803090242782, 53.66651288389397],
            [26.89603106934908, 53.67142134066211],
            [26.898887973362378, 53.678359907149684],
            [26.902887637723325, 53.681744159301275],
            [26.908887135162956, 53.6844513648133],
            [26.913458180146733, 53.68698921193118],
            [26.91688646388468, 53.69088028098872],
            [26.91774353571759, 53.69510929599073],
            [26.912601109212346, 53.699845288389895],
            [26.9051731602151, 53.70339693259973],
            [26.898602283050764, 53.70576452942498],
            [26.890031572807743, 53.71219019129495],
            [26.88403207536811, 53.71743145189754],
            [26.880889481941722, 53.72199588826754],
            [26.88288931412211, 53.72588372165808],
            [26.888031740627355, 53.72943316870868],
            [26.892602785611132, 53.73230631071419],
            [26.894316927480133, 53.73467228022412],
            [26.89688814118182, 53.74210731855152],
            [26.899173663673764, 53.74835849149474],
            [26.902601947411767, 53.75460873446718],
            [26.908315754539956, 53.759844708668936],
            [26.917457845405977, 53.76491115847563],
            [26.92288596132437, 53.7677818758948],
            [26.926885625685316, 53.7718343190632],
            [26.92831407814117, 53.775886370521505],
            [26.929742529698558, 53.77993803134859],
            [26.93259943281356, 53.78365171020778],
            [26.93517064561695, 53.788715287368916],
            [26.937741859318635, 53.79344074189794],
            [26.938027549630192, 53.79698448359642],
            [26.93745616900719, 53.80086538037881],
            [26.94059876243358, 53.80525204915335],
            [26.944027046171527, 53.807951309728764],
            [26.94631256866353, 53.81098776954872],
            [26.946026878351915, 53.81537337930405],
            [26.94316997523714, 53.81722869122291],
            [26.93945600118758, 53.81925257471892],
            [26.933456503747948, 53.82009583043998],
            [26.929742529698558, 53.82043312797708],
            [26.922314580701368, 53.82127635994118],
            [26.914600941392735, 53.82346868363368],
            [26.909458515785957, 53.82599814588866],
            [26.9057445408381, 53.82937052396926],
            [26.9057445408381, 53.836283050863244],
            [26.90317332803471, 53.842014525051866],
            [26.901173495854152, 53.84420576407655],
            [26.89660244997208, 53.84707105676125],
            [26.89055144549451, 53.85048544453059],
          ],
        ],
      },
      properties: {
        shapeName: "Stowbtsy",
        shapeISO: "",
        shapeID: "67162791B19818766020383",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
